import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddCircle } from "iconsax-reactjs";
import { toast } from "react-toastify";
import CategoyTree from "../../components/partials/category/CategoryTree";
import type { Category } from "../../services/webServices/category/types";
import { getCategoriesAll } from "../../services/webServices/category/get";
import { deleteCategory } from "../../services/webServices/category/delete";
import { useAdminLoading } from "../../context/AdminLoadingContext";
import { useInitialPageLoad } from "../../components/layouts/admin-layout/useInitialPageLoad";

export default function Category() {

  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const { showLoading, hideLoading } = useAdminLoading();
  const isFirstLoad = useInitialPageLoad();

  useEffect(() => {

    let isMounted = true;

    const fetchCategories = async () => {
      try {
        if(isFirstLoad) showLoading();
        setIsLoading(true);
        const data = await getCategoriesAll({ params: { depth: 0 } });
        if (isMounted) setCategories(data);
      } catch {
        if (isMounted) setError("خطا در دریافت دسته‌بندی‌ها");
      } finally {
        if (isMounted) {
          setIsLoading(false);
          if(isFirstLoad) hideLoading();
        }
      }
    };

    fetchCategories();

    return () => {
      isMounted = false;
    };
  }, [refreshKey]);

  useEffect(() => {
    // @ts-ignore
    window?.HSStaticMethods?.autoInit?.();
  }, [categories]);

  const handleEdit = (category: Category) => {
    navigate(`/add-category/${category.id}`, { state: { categories } });
  };

  const handleDelete = async (id: number) => {
    const success = await deleteCategory({ id });

    if (!success) return;

    toast.success("دسته بندی با موفقیت حذف شد")
    setRefreshKey((prev) => prev + 1);
    return true;
  };

  return (
    <div
      className="w-full flex flex-col gap-6 p-4 border rounded-2xl card-shadow bg-white min-h-screen mb-3"
      dir="rtl"
    >
      <div className="flex flex-row items-center px-4 pt-3 justify-between font-medium">
        <h1 className="flex flex-row items-center">
          <span
            style={{
              display: "inline-block",
              width: "5px",
              height: "1.2em",
              borderRadius: "4px",
              background: "#19AE89",
              marginLeft: "10px",
            }}
          />
          <span
            style={{
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "40px",
              color: "#23262F",
            }}
          >
            مدیریت دسته‌بندی‌ها
          </span>
        </h1>

        <button
          type="button"
          onClick={() => navigate("/add-category")}
          className="flex items-center gap-2 bg-primaryVar text-white px-4 py-2 rounded-lg hover:bg-darkPrimary text-sm"
        >
          <AddCircle className="w-5 h-5 text-white" />
          افزودن دسته جدید
        </button>
      </div>

      <div className="custom-dashed-border border-gray/50 mt-2" />

      <div className="w-full">

        {error && <div className="text-sm text-red-600">{error}</div>}

        {!isLoading && !error && (
          <CategoyTree
            categories={categories}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        )}
      </div>
    </div>
  );
};